// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"395e712f","430":"d8540d64","461":"849a201f","515":"e347123f","847":"12c9e171","873":"50e7d945","978":"4f034e44"}[chunkId] + ".css";
};